const inkAssociationsList = {
  controller: 'AssociationsListController',
  bindings: {
    decline: '&',
    accept: '&',
    edit: '&',
    onChange: '&',
    associations: '<',
    title: '<',
    type: '<'
  },
  template: require('./associations-list.template.html')
};

angular
  .module('inkfinder')
  .component('inkAssociationsList', inkAssociationsList);



// WEBPACK FOOTER //
// ./components/collector/associations/list/associations-list.component.js